var React = require('react');

function Campus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M246 333.6c1.6 1.3 4.3 1.6 6.1.7l177.8-88.8c1.8-.9 3.3-3.3 3.3-5.3V64.3c0-2-1.7-3.7-3.7-3.7h-67.7c-2 0-4.7 1.3-6 2.9l-172.1 214c-1.3 1.6-1 3.9.5 5.2l61.8 50.9zm96.1-270.1c1.3-1.6.7-2.9-1.4-2.9H59.1c-2 0-3.7 1.7-3.7 3.7v108.6c0 2 1.3 4.7 2.8 6l112 92.3c1.6 1.3 3.9 1.1 5.2-.5L342.1 63.5zM173.2 287.4c-1.6-1.3-3.7-3.1-4.8-3.9-1.1-.9-2-1.6-2-1.6s-1.3-1.1-2.8-2.4L58.3 192.8c-1.6-1.3-2.8-.7-2.8 1.3v234.7c0 2 1.5 2.9 3.3 2l176.3-88.1c1.8-.9 2-2.7.5-4l-62.4-51.3zm260-27.9c0-2-1.5-2.9-3.3-2L70.7 436.8c-1.8.9-1.6 1.6.4 1.6h358.4c2 0 3.7-1.7 3.7-3.7V259.5z","fill":"currentColor"}));
}

Campus.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = Campus;

Campus.default = Campus;
